import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Card, Col, Row, Spin, Typography, Button, Select, Modal, Upload, Input as AntInput, Button as AntButton, Icon, message } from 'antd';
import { fetchCenterBasicProfile, removeNetworkSpoc, changeCenterStatus, updateDiscountForAllSpecialists, uploadCSVDoctorDocument, fetchDoctorsDetailForCenterByCSV, uploadDoctorsDetailForCenterByCSV, createApporvalRequestForDiscountUpdate } from '../../services';
import { ButtonText } from "../../components/common/Text";
import { element } from 'prop-types';
import Papa from 'papaparse';
const { Paragraph, Title, Text } = Typography;

const { Option } = Select;

const EduRowComponent = styled.div`
  display: flex;
  flex-direction: column;
`;
let currentModal;

// const Row = styled.div`
//   display: flex;
//   flex-direction: row;
// `;

// const Col = styled.div`
//   display: flex;
//   flex: 1;
//   flex-direction: column;
//   margin-right: 10px;
// `;

class NetworkCenterSpecialistsScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      centerSpecialists: [],
      applicableTariff: null,
      centerStatus: 'pending',
      fetchedSpecialists: [],
      offlineDiscountOperation: 'percentage',
      offlineDiscount: null,
      originalSpecialists: [],
      searchInput: '',
      fileList: [],
      fileDoctorDetailFileList: [],
      csvfile: null,
      doctorDetailsfileName: null,
      uploadButtonText: 'Choose File',
      uploadStatus: '',
      doctorsDetailFileUploadingStatus: null,
      uploadDoctorsDetaileCsvFile: null,
      doctorsFailedData: null,
      discountLoader:false,
    };
    console.log({ props });

    this.centerId = props.centerId;
  }

  componentDidMount = () => {
    this.fetchSpecialists();
  };

  fetchSpecialists = () => {
    this.setState({ loading: true });
    fetchCenterBasicProfile(this.centerId)
      .then(res => {
        console.log({ res },
          '[fetchCenterBasicProfile] response');
        const basicProfile = res;
        const { specialists } = basicProfile;
        const { centerDetails } = basicProfile;
        if(centerDetails){
          this.setState({
            applicableTariff : centerDetails.applicableTariff,
          });
        }
        if (specialists) {
          this.setState({
            centerSpecialists: specialists,
          });
        }
        if (basicProfile.centerDetails && basicProfile.centerDetails.centerStatus) {
          this.setState({
            centerStatus: basicProfile.centerDetails.centerStatus,
          });
        }
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        const { centerSpecialists } = this.state;
        this.setState({ loading: false });
        this.setState({ originalSpecialists: centerSpecialists })
      });
  };

  openDoctorProfile = doctorId => () => {
    const { history } = this.props;
    history.push(`/doctor-profile/${doctorId}`);
  };

  handleChangeOnboardingStatus = (newStatus) => {
    Modal.confirm({
      title: 'Confirm Center Status',
      content: `Are you sure you want to change status to ${newStatus}?`,
      onOk: () => {
        return changeCenterStatus(this.centerId, newStatus)
          .then(this.fetchSpecialists);
      },
    });
  };

// Function to handle the modal display
handleDiscountChange = () => {
  Modal.confirm({
    title: (
      <div style={{ color: 'red', fontWeight: 'bold' }}>
        Warning: Discount Changes Detected
      </div>
    ),
    content: (
      <div>

        <hr style={{ border: '1px solid #f0f0f0', margin: '10px 0' }} />
        <p style={{ fontWeight: 'bold' }}>
          Changing discount will update the discount at centre level and it will
          go under approval process. Are you sure you want to proceed with the
          update?
        </p>
        <div
          style={{
            border: '1px solid red',
            padding: '10px',
            backgroundColor: '#fff5f5',
            marginTop: '10px',
          }}
        >
          <strong>Note:</strong> By continuing, you acknowledge and agree to the
          terms and conditions of Visit Health Pvt Ltd, including
          responsibilities related to mismanagement, penalties, and incorrect
          updates.
        </div>
        <hr style={{ border: '1px solid #f0f0f0', marginTop: '10px' }} />
      </div>
    ),
    icon: null, // No default icon to use custom styling
    okText: 'Continue',
    okType: 'primary',
    cancelText: 'Cancel',
    onOk: () => {
      return this.createApprovalRequestForDiscount();
    },
    onCancel: () => {},
    width: 600,
  });
};

handlePriceChangeForCsv = () => {
  Modal.confirm({
    title: (
      <div style={{ color: 'red', fontWeight: 'bold' }}>
        Warning: File may contain Price Related Changes
      </div>
    ),
    content: (
      <div>
        
        <hr style={{ border: '1px solid #f0f0f0', margin: '10px 0' }} />
        <p>
          This file may contain price-related changes and it will go under the approval process.
          Are you sure you want to proceed with the update?
        </p>
        <div
          style={{
            border: '1px solid red',
            padding: '10px',
            backgroundColor: '#fff5f5',
            marginTop: '10px',
          }}
        >
          <strong>Note:</strong> By continuing, you acknowledge and agree to the terms and conditions of Visit Health Pvt Ltd, including responsibilities related to mismanagement, penalties, and incorrect updates.
        </div>
        <hr style={{ border: '1px solid #f0f0f0', marginTop: '10px' }} />
      </div>
    ),
    icon: null, // No default icon to use custom styling
    okText: 'Continue',
    okType: 'primary',
    cancelText: 'Cancel',
    width: 600, // More rectangular shape // Optional: Adjust vertical position
    onOk: () => {
      console.log('Price change confirmed');
      this.handleDoctorDetailsUpload({
        file: this.state.uploadDoctorsDetaileCsvFile,
      });
    },
    onCancel: () => {
      console.log('Price change canceled');
      // Replace this with your cancellation logic
    },
  });
};


handleCsvFileStatus = (msg, apiStatus) => {
  const seconds = 3;

  if (currentModal) {
    currentModal.destroy();
  }

  switch (apiStatus) {
    case 'success':
      currentModal = Modal.success({
        title: msg || 'Operation completed successfully!',
      });
      break;
    case 'error':
      currentModal = Modal.error({
        title: msg || 'An error occurred during the operation.',
      });
      break;
    case 'warning':
      currentModal = Modal.warning({
        title: msg || 'This is a warning about the operation.',
      });
      break;
    case 'info':
      currentModal = Modal.info({
        title: msg || 'This is some information regarding the operation.',
      });
      break;
    default:
      currentModal = Modal.info({
        title: 'Unknown status',
      });
      break;
  }

  if (apiStatus === 'success' || apiStatus === 'failed') {
    setTimeout(() => {
      currentModal.destroy();
      currentModal = null; // Reset the modal reference after it's destroyed
    }, seconds * 1000);
  }
};

  createApprovalRequestForDiscount = () => {
    const { offlineDiscount, offlineDiscountOperation } = this.state;
    const centerId = this.centerId;
    const discountPayload = {
      offlineDiscount,
      offlineDiscountOperation,
      centerId
    };
    this.setState({
      discountLoader:true
    })
    createApporvalRequestForDiscountUpdate(discountPayload)
      .then((res) => {
        this.setState({ offlineDiscount: '' });
        this.setState({
          discountLoader:false
        })
        alert('Request Created Successfully for Updating Discount');
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({
          discountLoader:false
        })
      })
  }

  searchHandler = (e) => {
    const value = e.target.value;
    this.setState({ searchInput: value });
    const { centerSpecialists } = this.state;
    console.log(`\nCurrent search value:${value}`);

    if (value.trim() === '') {
      this.setState({ originalSpecialists: centerSpecialists });
      return;
    }
    const pattern = new RegExp(value, 'gi');
    this.setState({
      originalSpecialists: centerSpecialists.filter((ele) => {
        // Search algo
        return ele.doctorName.match(pattern);
      })
    })
  }

  handleChange = ({ fileList }) => {
    console.log(fileList, "on change csv");
    this.setState({ fileList });
  };

  downloadDoctorDetail = () => {
    const centerId = this.centerId;

    console.log("centerId", centerId);

    fetchDoctorsDetailForCenterByCSV(centerId)
      .then((res) => {
        console.log(res);

        // Assuming `res.data` contains an array of doctor details
        if (res.data && res.data.length > 0) {
          const headers = Object.keys(res.data[0]).join(","); // Get headers from the keys of the first object

          const rows = res.data
            .map((doctor) =>
              Object.values(doctor)
                .map(value => {
                  // Handle null or undefined values by converting them to an empty string
                  if (value === null || value === undefined) {
                    return '';
                  }

                  // Convert value to string and handle potential issues with CSV format
                  const stringValue = String(value);

                  // If the value contains a comma, double-quote, or newline, it needs to be escaped
                  if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
                    // Escape double quotes by doubling them
                    return `"${stringValue.replace(/"/g, '""')}"`;
                  }

                  return stringValue;
                })
                .join(",")
            )
            .join("\n"); // Map each doctor's values to a CSV row

          const csvContent = `${headers}\n${rows}`; // Combine headers and rows

          // Create the CSV file
          const blob = new Blob([csvContent], { type: 'text/csv' });
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'doctors_detail.csv'; // Specify the filename
          a.click();
          URL.revokeObjectURL(url); // Clean up
        }
        this.handleCsvFileStatus("Doctor's details downloaded successfully", 'success');
      })
      .catch((err) => {
        console.log(err);
        this.setState({ uploadStatus: 'failed' });
        this.setState({ doctorsDetailFileUploadingStatus: 'failed' });

        this.handleCsvFileStatus("Failed to download doctor's details", 'error');
      })
      .finally(() => {
        this.setState({
          uploadStatus: '',
        });
      });
  };



  downloadFailedDataFile = () => {
    // Get the failed data from doctorsFailedData
    console.log("doctorsFailedData", this.state.doctorsFailedData);
    const failedData = this.state.doctorsFailedData;

    // Convert the JSON data into CSV format
    const csvData = Papa.unparse(failedData);

    // Create a Blob from the CSV string
    const blob = new Blob([csvData], { type: 'text/csv' });

    // Create a temporary download link
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'doctors_failed_data.csv'; // Specify the filename
    a.click();

    // Revoke the object URL to free up memory
    URL.revokeObjectURL(url);
  };


  // Function to handle file input changes
  handleDoctorDetailFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      this.setState({
        uploadDoctorsDetaileCsvFile: file,
        doctorDetailsfileName: file.name,
        uploadStatus: 'uploaded'
      });
      message.success(`${file.name} uploaded successfully. Details updation is in progress`);
    } else if (file.status === 'error') {
      this.setState({ uploadStatus: 'failed' });
      message.error(`${file.name} file upload failed.`);
    }
  };

  handleDoctorDetailsUpload = async ({ file }) => {
    try {
      console.log("File object before upload:", file);
      this.handleCsvFileStatus("Wait...", 'info');
      const isCSV = file.type === 'text/csv';
      if (!isCSV) {
        message.error('You can only upload CSV files!');
        return;
      }

      const res = await uploadDoctorsDetailForCenterByCSV(file, file.name, this.centerId);
      if (res.message === 'success') {
        this.setState({ uploadStatus: 'success', doctorsDetailFileUploadingStatus: 'success' });
        this.handleCsvFileStatus("Doctor's Details Uploaded Successfully", 'success');
        this.fetchSpecialists(this.centerId);
      } else if (res.message === 'faultedData') {
        this.setState({ uploadStatus: 'failed', doctorsDetailFileUploadingStatus: 'faultedData', doctorsFailedData: res.data });
        this.handleCsvFileStatus(res.errorMessage || "Some uploaded data is incorrect", 'error');
      } else {
        this.setState({ uploadStatus: 'failed', doctorsDetailFileUploadingStatus: 'failed', doctorsFailedData: res.data });
        this.handleCsvFileStatus("Something went wrong", 'error');
      }

    } catch (err) {
      this.setState({ uploadStatus: 'failed', doctorsDetailFileUploadingStatus: 'failed' });
      this.handleCsvFileStatus("Failed to upload doctor's details", 'error');
    }
  };

  handleRemove = (file) => {
    this.setState(prevState => ({
      fileDoctorDetailFileList: prevState.fileDoctorDetailFileList.filter(f => f.uid !== file.uid),
      doctorDetailsfileName: '',
      uploadStatus: ''
    }));
  };

  handleButtonClick = () => {
    const { uploadDoctorsDetaileCsvFile, uploadStatus } = this.state;
    if (uploadDoctorsDetaileCsvFile && uploadStatus !== 'uploading') {
      // this.handleDoctorDetailsUpload({
      //   file: this.state.uploadDoctorsDetaileCsvFile,
      // });
      this.handlePriceChangeForCsv();
    } else {
      // Open the file dialog
      this.uploadInput.click();
    }
  };

  // Ref to the hidden file input
  setUploadInputRef = (node) => {
    this.uploadInput = node;
  };

  handleUpload = (response) => {
    const { centerId } = this.props;
    const { documentCategory, mouLogIds } = this.state;
    this.setState({ csvfile: response.file })
    console.log(centerId, 'HandleUpload');
    console.log(response.file.uid, 'HandleUpload Response UID Check');
    return uploadCSVDoctorDocument(centerId, response.file, response.onProgress)
      .then((resInfo) => {
        console.log(resInfo, 'upload CSV Document response')

        response.onSuccess(response, response.file);
        message.success('Created doctor profiles');
        this.fetchSpecialists();
      })
      .catch((err) => {
        response.onError(err);
      });
  };

  
  render() {
    const { loading, centerSpecialists, centerStatus, offlineDiscountOperation, offlineDiscount, originalSpecialists, searchInput, fileList, doctorDetailsfileName, uploadButtonText, fileDoctorDetailFileList, uploadStatus, doctorsDetailFileUploadingStatus } = this.state;
    const { history } = this.props;
    const offlineDiscountType = (
      <Select
        value={offlineDiscountOperation}
        onChange={e => this.setState({ offlineDiscountOperation: e })}
      >
        <Option value="percentage">Percentage</Option>
        <Option value="fixed">Fixed Value</Option>
      </Select>
    );
    const getStatusStyles = (status) => {
      switch (status || 'pending') {
        case 'pending':
          return { color: '#ffb703' };
        case 'live':
          return { color: '#02bf6a', };
        case 'not-live':
          return { color: '#f77d0a', };
        default:
          return { color: 'black', };
      }
    };
    const getStatusText = (status) => {
      switch (status || 'pending') {
        case 'pending':
          return 'Pending';
        case 'live':
          return 'Live';
        case 'not-live':
          return 'Not Live';
        default:
          return '';
      }
    };
    const renderSpecialist = (ele, idx) => {
      return (
        <Col key={idx} span={24} xs={24} md={12}>
          <Card>
            <EduRowComponent>
              <Row type="flex" align="middle" justify="space-between">
                <Col>
                  <Row type="flex" align="middle" gutter={[16, 16]}>
                    <Col style={{ flexGrow: 1 }}>
                      <Title level={4} style={{ margin: 0 }}>
                        {ele.doctorName}
                      </Title>
                    </Col>
                    <Col>
                      <Button
                        icon="edit"
                        onClick={this.openDoctorProfile(ele.doctorId)}
                      >
                        Doctor Profile
                      </Button>
                    </Col>
                    {ele.status && <Col style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto' }}>
                      <span
                        style={{
                          height: '10px',
                          width: '10px',
                          borderRadius: '50%',
                          display: 'inline-block',
                          marginRight: '5px',
                          backgroundColor: getStatusStyles(ele.status).color,
                        }}
                      ></span>
                      <strong style={{ margin: 0, color: getStatusStyles(ele.status).color }}>
                        {getStatusText(ele.status)}
                      </strong>
                    </Col>
                    }
                  </Row>

                </Col>
              </Row>
              <Row gutter={[16, 16]}>
                <Col xs={24}>
                  <Paragraph strong style={{ margin: 0 }}>
                    {ele.vertical}
                  </Paragraph>
                </Col>
                <Col xs={24}>
                  <Paragraph style={{ margin: 0 }}>
                    {ele.qualifications}
                  </Paragraph>
                  <Paragraph style={{ margin: 0 }}>
                    <strong>Fee</strong> {" - "}
                    {`${ele.fee} ₹`}
                  </Paragraph>
                  <Paragraph style={{ margin: 0 }}>
                    <strong>OFFLINE DISCOUNT</strong> {" - "} 
                    {ele.offlineDiscountOperation === 'percentage' ? `${ele.offlineDiscount} %` : `Rs. ${ele.offlineDiscount}`}
                  </Paragraph>
                </Col>
              </Row>
            </EduRowComponent>
          </Card>
        </Col>
      );
    };
    return (
      <Row type="flex" align="middle" gutter={[16, 16]}>
        <React.Fragment>
          <Col span={30}>
            <Title type={2}>Center Specialists</Title>
          </Col>
          {loading ? (
            <div>
              <Spin />
            </div>
          ) : (
            <React.Fragment>
              <Row
                style={{ marginLeft: 20 }}
              >{`Number of Specialists: ${centerSpecialists.length}`}</Row>
              <Col span={16}>
                <Row style={{ marginLeft: '8px' }}>
                  <Col span={16}>On-boarding Status</Col>
                  <Col spn={8}>
                    <Select
                      style={{ width: '50%' }}
                      onSelect={e => {
                        this.handleChangeOnboardingStatus(e);
                      }}
                      value={centerStatus}
                    >
                      <Option value="pending">Pending</Option>
                      <Option value="not-live">Not Live</Option>
                      <Option value="live">Live</Option>
                    </Select>

                  </Col>

                </Row>
                {this.state.applicableTariff && (
                  <Row style={{ marginLeft: '8px', marginTop: '15px' }}>
                    <Col span={24}>
                      <span style={{ fontWeight: 600 }}>Doctor Tariff : </span>{" "}
                      <span style={{ fontWeight: 600, color: "#1890ff" }}>
                        {this.state.applicableTariff}
                      </span>
                    </Col>
                  </Row>
                )}

              </Col>
              <Col span={8}>Upload doctors list (only csv files) &nbsp;
                <Upload
                  accept=".csv"
                  fileList={fileList}
                  onChange={this.handleChange}
                  onRemove={this.handleRemove}
                  beforeUpload={this.beforeUpload}
                  customRequest={this.handleUpload}
                >
                  <AntButton>
                    <Icon type="upload" /> Upload
                  </AntButton>

                </Upload>
                <a href='https://visit-public.s3.ap-south-1.amazonaws.com/Doctors-Upload-Template.csv' download='testDataDoctors' target="_blank"> download sample file </a>
              </Col>

              <Col span={24}>
                <Col span={9}>
                  <Row align="middle" style={{ marginBottom: '10px' }}>
                    <div style={{ border: '1px solid #EBEAF5', padding: '16px', borderRadius: '5px', width: '100%' }}>
                      <Row>
                        <Col span={12}>
                          <Text
                            onClick={this.downloadDoctorDetail}
                            style={{ cursor: 'pointer', color: '#714FFF', textDecoration: 'underline' }}
                          >
                            Download Doctor Detail
                          </Text>
                        </Col>
                      </Row>
                      <Row style={{ marginTop: '20px' }}>
                        <Col span={8}>
                          <Text style={{
                            color: '#0F0B28',
                          }}>Update doctor's details</Text>
                        </Col>
                        <Col span={8}>
                          <Text style={{
                            color: uploadStatus === 'uploading' ? '#ffe58f' : '#714FFF',
                          }}>{doctorDetailsfileName}</Text>
                        </Col>
                        <Col span={8} style={{ textAlign: 'right' }}>
                          <input
                            type="file"
                            accept=".csv"
                            style={{ display: 'none' }}
                            ref={this.setUploadInputRef}
                            onChange={(e) => this.handleDoctorDetailFileChange(e)}
                          />
                          <Button
                            type="primary"
                            onClick={this.handleButtonClick}
                            style={{
                              backgroundColor: '#ffffff',
                              borderColor: uploadStatus === 'uploading' ? '#ffe58f' : '#714FFF',
                              color: uploadStatus === 'uploading' ? '#ffe58f' : '#714FFF',
                            }}
                          >
                            {uploadStatus === 'uploading' ? 'Uploading...' : (this.state.uploadDoctorsDetaileCsvFile ? 'Upload File' : 'Choose File')}
                          </Button>
                        </Col>
                      </Row>
                      <Row style={{ marginTop: '5px' }}>
                        <Col span={12}>
                          <Text
                            // Conditionally set the onClick handler only if status is 'failed'
                            onClick={doctorsDetailFileUploadingStatus == 'faultedData' ? this.downloadFailedDataFile : null}
                            style={{
                              cursor: doctorsDetailFileUploadingStatus == 'faultedData' ? 'pointer' : 'default', // Pointer if clickable
                              textDecoration: doctorsDetailFileUploadingStatus == 'faultedData' ? 'underline' : '',
                              color: doctorsDetailFileUploadingStatus == 'success' ? '#56AE3D' : '#F5BF7F',
                              fontWeight: 'bold'
                            }}
                          >
                            {doctorsDetailFileUploadingStatus == null
                              ? ''
                              : doctorsDetailFileUploadingStatus == 'success'
                                ? 'Successfull'
                                  : doctorsDetailFileUploadingStatus == 'faultedData' ? 'Download Failed Data':''}
                          </Text>
                        </Col>
                      </Row>
                    </div>
                  </Row>
                </Col>
              </Col>





              <Col span={12}>
                <Col span={6}><label>Search Specialists</label></Col>
                <Col span={16}>
                  <AntInput style={{ width: '100%' }} placeholder="Specialist name" value={searchInput} onChange={this.searchHandler} />
                </Col>
              </Col>
              <Col span={4}><label style={{ marginLeft: '60px' }}>Offline Discount</label></Col>
              <Col span={4}>
                <AntInput
                  value={offlineDiscount}
                  addonBefore={offlineDiscountType}
                  onChange={(e) => {
                    this.setState({
                      offlineDiscount: Number.parseFloat(e.target.value) || 0
                    })
                  }}
                  placeholder="Discount"
                />
              </Col>
              <Col span={2}>
                <Button style={{width:'190px', background:'red', border:'1px solid red', display:'flex', justifyContent:'center', alignItems:'center'}} block type="primary" size="middle" 
                onClick={this.handleDiscountChange}
                disabled={this.state.offlineDiscount == null || this.state.discountLoader}>
                  {this.state.discountLoader &&  <Spin style={{paddingRight:'10px'}} size="small" />}
                  <ButtonText>Send Approval Request</ButtonText>
                </Button>
              </Col>
              <Col span={24}>{originalSpecialists.map(renderSpecialist)}</Col>
            </React.Fragment>
          )}
        </React.Fragment>
      </Row>
    );
  }
}

const mapStateToProps = state => ({
  authToken: state.user.authToken,
});

export default withRouter(
  connect(mapStateToProps)(NetworkCenterSpecialistsScreen)
);
